// extracted by mini-css-extract-plugin
export default {"layout":"DefaultLayout_layout__PSEXa","body":"DefaultLayout_body__7I0OR"};